// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/js/components/pages/newLandingPage/block-types/styles.less
// module id = 1122
// module chunks = 10